import { usePartialAppSelector } from 'shared/hooks/redux/hooks';
import { useDeviceConfig } from '../../contexts/device/config';
import { selectDevice, selectSelectedDevice } from 'entities/device/lib/selectors';
export const useSelectDevice = (subset_selector) => {
    const { device_id } = useDeviceConfig();
    const selected_device = usePartialAppSelector(device_id ? selectDevice : selectSelectedDevice, device_id);
    return subset_selector(selected_device);
};
